import * as SlotPrimitive from '@radix-ui/react-slot';

export const Root = SlotPrimitive.Root;
export const Slot = SlotPrimitive.Root;
export const Slottable = SlotPrimitive.Slottable;
